/* eslint-disable @upgrade/no-template-literal-font-size */
import styled from 'styled-components';

// eslint-disable-next-line import/prefer-default-export
export const Table = styled.table`
  width: 100%;
  font-size: ${({
  'data-responsive': r
}) => r ? '0.875rem' : '1rem'};
  th,
  td {
    padding: ${({
  'data-padded': padded
}) => padded ? '.5rem 0' : '0'};
  }

  @media (min-width: ${props => props.theme.mediaSm}) {
    font-size: 1rem;
    td,
    th {
      padding: ${({
  'data-padded': padded
}) => padded ? '.75rem 0' : 0};
    }
  }
`;
//# sourceMappingURL=styles.js.map